// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
:where(.tvp-proview_root) ::before,
:where(.tvp-proview_root) ::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
  --tw-content: "";
}
:where(.tvp-proview_root) html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Graphik, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}
:where(.tvp-proview_root) body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
:where(.tvp-proview_root) hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
:where(.tvp-proview_root) abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
:where(.tvp-proview_root) h1,
:where(.tvp-proview_root) h2,
:where(.tvp-proview_root) h3,
:where(.tvp-proview_root) h4,
:where(.tvp-proview_root) h5,
:where(.tvp-proview_root) h6 {
  font-size: inherit;
  font-weight: inherit;
}
:where(.tvp-proview_root) a {
  color: inherit;
  text-decoration: inherit;
}
:where(.tvp-proview_root) b,
:where(.tvp-proview_root) strong {
  font-weight: bolder;
}
:where(.tvp-proview_root) code,
:where(.tvp-proview_root) kbd,
:where(.tvp-proview_root) samp,
:where(.tvp-proview_root) pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}
:where(.tvp-proview_root) small {
  font-size: 80%;
}
:where(.tvp-proview_root) sub,
:where(.tvp-proview_root) sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
:where(.tvp-proview_root) sub {
  bottom: -0.25em;
}
:where(.tvp-proview_root) sup {
  top: -0.5em;
}
:where(.tvp-proview_root) table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
:where(.tvp-proview_root) button,
:where(.tvp-proview_root) input,
:where(.tvp-proview_root) optgroup,
:where(.tvp-proview_root) select,
:where(.tvp-proview_root) textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
:where(.tvp-proview_root) label {
  font-weight: 400;
}
:where(.tvp-proview_root) button,
:where(.tvp-proview_root) select {
  text-transform: none;
}
:where(.tvp-proview_root) button,
:where(.tvp-proview_root) [type="button"],
:where(.tvp-proview_root) [type="reset"],
:where(.tvp-proview_root) [type="submit"] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
:where(.tvp-proview_root) :-moz-focusring {
  outline: auto;
}
:where(.tvp-proview_root) :-moz-ui-invalid {
  box-shadow: none;
}
:where(.tvp-proview_root) progress {
  vertical-align: baseline;
}
:where(.tvp-proview_root) ::-webkit-inner-spin-button,
:where(.tvp-proview_root) ::-webkit-outer-spin-button {
  height: auto;
}
:where(.tvp-proview_root) [type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
:where(.tvp-proview_root) ::-webkit-search-decoration {
  -webkit-appearance: none;
}
:where(.tvp-proview_root) ::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
:where(.tvp-proview_root) summary {
  display: list-item;
}
:where(.tvp-proview_root) blockquote,
:where(.tvp-proview_root) dl,
:where(.tvp-proview_root) dd,
:where(.tvp-proview_root) h1,
:where(.tvp-proview_root) h2,
:where(.tvp-proview_root) h3,
:where(.tvp-proview_root) h4,
:where(.tvp-proview_root) h5,
:where(.tvp-proview_root) h6,
:where(.tvp-proview_root) hr,
:where(.tvp-proview_root) figure,
:where(.tvp-proview_root) p,
:where(.tvp-proview_root) pre {
  margin: 0;
}
:where(.tvp-proview_root) fieldset {
  margin: 0;
  padding: 0;
}
:where(.tvp-proview_root) legend {
  padding: 0;
}
:where(.tvp-proview_root) ol,
:where(.tvp-proview_root) ul,
:where(.tvp-proview_root) menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
:where(.tvp-proview_root) dialog {
  padding: 0;
}
:where(.tvp-proview_root) textarea {
  resize: vertical;
}
:where(.tvp-proview_root) input::-moz-placeholder, :where(.tvp-proview_root) textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
:where(.tvp-proview_root) input::placeholder,
:where(.tvp-proview_root) textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
:where(.tvp-proview_root) button,
:where(.tvp-proview_root) [role="button"] {
  cursor: pointer;
}
:where(.tvp-proview_root) :disabled {
  cursor: default;
}
:where(.tvp-proview_root) img,
:where(.tvp-proview_root) svg,
:where(.tvp-proview_root) video,
:where(.tvp-proview_root) canvas,
:where(.tvp-proview_root) audio,
:where(.tvp-proview_root) iframe,
:where(.tvp-proview_root) embed,
:where(.tvp-proview_root) object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
:where(.tvp-proview_root) img,
:where(.tvp-proview_root) video {
  max-width: 100%;
  height: auto;
}
:where(.tvp-proview_root) [hidden] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/scoped-preflight.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,0BAAwD,EAAE,MAAM;EAIhE,gBAAgB;AAHlB;AAKA;EACE,gBAAgB,EAAE,MAAM;EACxB,8BAA8B,EAAE,MAAM;EACtC,gBAAgB,EAAE,MAAM;EACxB,cAAW;KAAX,WAAW,EAAE,MAAM;EACnB,gCAgBC,EAAE,MAAM;EACT,6BAA8E,EAAE,MAAM;EACtF,+BAAkF,EAAE,MAAM;AAC5F;AACA;EACE,SAAS,EAAE,MAAM;EACjB,oBAAoB,EAAE,MAAM;AAC9B;AACA;EACE,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;AAC/B;AACA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;AACA;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;EAIE,+GAUC,EAAE,MAAM;EACT,cAAc,EAAE,MAAM;AACxB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;EAC7B,yBAAyB,EAAE,MAAM;AACnC;AACA;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,8BAA8B,EAAE,MAAM;EACtC,gCAAgC,EAAE,MAAM;EACxC,eAAe,EAAE,MAAM;EACvB,oBAAoB,EAAE,MAAM;EAC5B,oBAAoB,EAAE,MAAM;EAC5B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,UAAU,EAAE,MAAM;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;;EAIE,0BAA0B,EAAE,MAAM;EAClC,6BAA6B,EAAE,MAAM;EACrC,sBAAsB,EAAE,MAAM;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;;;;;;;;EAaE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EAEE,UAAU,EAAE,MAAM;EAClB,cAAwC,EAAE,MAAM;AAClD;AAJA;;EAEE,UAAU,EAAE,MAAM;EAClB,cAAwC,EAAE,MAAM;AAClD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;EAQE,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AAChC;AACA;;EAEE,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf","sourcesContent":["/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n:where(.tvp-proview_root) ::before,\n:where(.tvp-proview_root) ::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: theme(\"borderColor.DEFAULT\", currentColor); /* 2 */\n}\n:where(.tvp-proview_root) ::before,\n:where(.tvp-proview_root) ::after {\n  --tw-content: \"\";\n}\n:where(.tvp-proview_root) html {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  tab-size: 4; /* 3 */\n  font-family: theme(\n    \"fontFamily.sans\",\n    ui-sans-serif,\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    \"Helvetica Neue\",\n    Arial,\n    \"Noto Sans\",\n    sans-serif,\n    \"Apple Color Emoji\",\n    \"Segoe UI Emoji\",\n    \"Segoe UI Symbol\",\n    \"Noto Color Emoji\"\n  ); /* 4 */\n  font-feature-settings: theme(\"fontFamily.sans[1].fontFeatureSettings\", normal); /* 5 */\n  font-variation-settings: theme(\"fontFamily.sans[1].fontVariationSettings\", normal); /* 6 */\n}\n:where(.tvp-proview_root) body {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n:where(.tvp-proview_root) hr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n:where(.tvp-proview_root) abbr:where([title]) {\n  text-decoration: underline dotted;\n}\n:where(.tvp-proview_root) h1,\n:where(.tvp-proview_root) h2,\n:where(.tvp-proview_root) h3,\n:where(.tvp-proview_root) h4,\n:where(.tvp-proview_root) h5,\n:where(.tvp-proview_root) h6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n:where(.tvp-proview_root) a {\n  color: inherit;\n  text-decoration: inherit;\n}\n:where(.tvp-proview_root) b,\n:where(.tvp-proview_root) strong {\n  font-weight: bolder;\n}\n:where(.tvp-proview_root) code,\n:where(.tvp-proview_root) kbd,\n:where(.tvp-proview_root) samp,\n:where(.tvp-proview_root) pre {\n  font-family: theme(\n    \"fontFamily.mono\",\n    ui-monospace,\n    SFMono-Regular,\n    Menlo,\n    Monaco,\n    Consolas,\n    \"Liberation Mono\",\n    \"Courier New\",\n    monospace\n  ); /* 1 */\n  font-size: 1em; /* 2 */\n}\n:where(.tvp-proview_root) small {\n  font-size: 80%;\n}\n:where(.tvp-proview_root) sub,\n:where(.tvp-proview_root) sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n:where(.tvp-proview_root) sub {\n  bottom: -0.25em;\n}\n:where(.tvp-proview_root) sup {\n  top: -0.5em;\n}\n:where(.tvp-proview_root) table {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n:where(.tvp-proview_root) button,\n:where(.tvp-proview_root) input,\n:where(.tvp-proview_root) optgroup,\n:where(.tvp-proview_root) select,\n:where(.tvp-proview_root) textarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n:where(.tvp-proview_root) label {\n  font-weight: 400;\n}\n:where(.tvp-proview_root) button,\n:where(.tvp-proview_root) select {\n  text-transform: none;\n}\n:where(.tvp-proview_root) button,\n:where(.tvp-proview_root) [type=\"button\"],\n:where(.tvp-proview_root) [type=\"reset\"],\n:where(.tvp-proview_root) [type=\"submit\"] {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}\n:where(.tvp-proview_root) :-moz-focusring {\n  outline: auto;\n}\n:where(.tvp-proview_root) :-moz-ui-invalid {\n  box-shadow: none;\n}\n:where(.tvp-proview_root) progress {\n  vertical-align: baseline;\n}\n:where(.tvp-proview_root) ::-webkit-inner-spin-button,\n:where(.tvp-proview_root) ::-webkit-outer-spin-button {\n  height: auto;\n}\n:where(.tvp-proview_root) [type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n:where(.tvp-proview_root) ::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n:where(.tvp-proview_root) ::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n:where(.tvp-proview_root) summary {\n  display: list-item;\n}\n:where(.tvp-proview_root) blockquote,\n:where(.tvp-proview_root) dl,\n:where(.tvp-proview_root) dd,\n:where(.tvp-proview_root) h1,\n:where(.tvp-proview_root) h2,\n:where(.tvp-proview_root) h3,\n:where(.tvp-proview_root) h4,\n:where(.tvp-proview_root) h5,\n:where(.tvp-proview_root) h6,\n:where(.tvp-proview_root) hr,\n:where(.tvp-proview_root) figure,\n:where(.tvp-proview_root) p,\n:where(.tvp-proview_root) pre {\n  margin: 0;\n}\n:where(.tvp-proview_root) fieldset {\n  margin: 0;\n  padding: 0;\n}\n:where(.tvp-proview_root) legend {\n  padding: 0;\n}\n:where(.tvp-proview_root) ol,\n:where(.tvp-proview_root) ul,\n:where(.tvp-proview_root) menu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n:where(.tvp-proview_root) dialog {\n  padding: 0;\n}\n:where(.tvp-proview_root) textarea {\n  resize: vertical;\n}\n:where(.tvp-proview_root) input::placeholder,\n:where(.tvp-proview_root) textarea::placeholder {\n  opacity: 1; /* 1 */\n  color: theme(\"colors.gray.400\", #9ca3af); /* 2 */\n}\n:where(.tvp-proview_root) button,\n:where(.tvp-proview_root) [role=\"button\"] {\n  cursor: pointer;\n}\n:where(.tvp-proview_root) :disabled {\n  cursor: default;\n}\n:where(.tvp-proview_root) img,\n:where(.tvp-proview_root) svg,\n:where(.tvp-proview_root) video,\n:where(.tvp-proview_root) canvas,\n:where(.tvp-proview_root) audio,\n:where(.tvp-proview_root) iframe,\n:where(.tvp-proview_root) embed,\n:where(.tvp-proview_root) object {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n:where(.tvp-proview_root) img,\n:where(.tvp-proview_root) video {\n  max-width: 100%;\n  height: auto;\n}\n:where(.tvp-proview_root) [hidden] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
